import React, { Component } from "react";
import PropTypes from "prop-types";

import Icon from "platopulse/components/Icon.jsx";
import FieldWidget from './FieldWidget.jsx';
import SelectionModule from './SelectionModule.jsx';

import _ from "underscore";

export default class SortWidget extends Component {
    constructor(props, context) {
        super(props, context);

        _.bindAll(this, "setDirection", "setField");
    }

    static propTypes = {
        sort: PropTypes.array.isRequired,
        fieldOptions: PropTypes.object.isRequired,
        customFieldOptions: PropTypes.object,
        tableName: PropTypes.string,
        updateOrderBy: PropTypes.func.isRequired,
        removeOrderBy: PropTypes.func.isRequired,
        tableMetadata: PropTypes.object.isRequired
    };

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            field: newProps.sort[0],           // id of the field
            direction: newProps.sort[1]        // sort direction
        });
    }

    componentWillUnmount() {
        // Remove partially completed sort if the widget is removed
        if (this.state.field == null || this.state.direction == null) {
            this.props.removeOrderBy();
        }
    }

    setField(value) {
        if (this.state.field !== value) {
            this.props.updateOrderBy([value, this.state.direction]);
            // Optimistically set field state so componentWillUnmount logic works correctly
            this.setState({ field: value });
        }
    }

    setDirection(value) {
        if (this.state.direction !== value) {
            this.props.updateOrderBy([this.state.field, value]);
            // Optimistically set direction state so componentWillUnmount logic works correctly
            this.setState({ direction: value });
        }
    }

    render() {
        var directionOptions = [
            {key: "ascending", val: "ascending"},
            {key: "descending", val: "descending"},
        ];

        return (
            <div className="flex align-center">
                <FieldWidget
                    query={this.props.query}
                    className="Filter-section Filter-section-sort-field SelectionModule"
                    tableMetadata={this.props.tableMetadata}
                    field={this.state.field}
                    fieldOptions={this.props.fieldOptions}
                    customFieldOptions={this.props.customFieldOptions}
                    setField={this.setField}
                    isInitiallyOpen={this.state.field === null}
                    enableSubDimensions={false}
                />

                <SelectionModule
                    className="Filter-section Filter-section-sort-direction"
                    placeholder="..."
                    items={directionOptions}
                    display="key"
                    selectedValue={this.state.direction}
                    selectedKey="val"
                    isInitiallyOpen={false}
                    action={this.setDirection}
                />

                <a onClick={this.props.removeOrderBy}>
                    <Icon name='close' size={12} />
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./query_builder/components/SortWidget.jsx